export const uuid4 = (): any => {
  const v4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

  return v4() + v4() + '-' + v4() + '-' + v4() + '-' + v4() + '-' + v4() + v4() + v4();
};
